const SurfaceFilter = {
  data() {
    return {
      activeSurfaces: this.activeItems
    }
  },
  props: [
    'activeItems'
  ],
  watch: {
    activeItems(newValue) {
      this.activeSurfaces = newValue
    }
  },
  methods: {
    handleInput: function(event) {
      bus.$emit('surface_filter', event.target.value)
    },
  }
}

export default SurfaceFilter
